/**
 * List of car brands that trigger specific flow stops in the car search process.
 * Test: Ferrari === EA 57 873
 */

export const listOfBrandFlowStops = [
	'ASTON MARTIN',
	'BENTLEY',
	'BUGATTI',
	'FERRARI',
	'HUMMER',
	'LAMBORGHINI',
	'MASERATI',
	'ROLLS ROYCE',
	'PAGANI',
	'KOENIGSEGG',
	'MCLAREN',
	'MAYBACH',
	'FISKER',
];
